import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_sm_badge = _resolveComponent("sm-badge")!
  const _component_sm_text = _resolveComponent("sm-text")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    dark: "",
    touchless: "",
    modelValue: _ctx.isVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isVisible) = $event)),
    width: 220,
    color: "secondary"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list, { class: "pa-0" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              (item.navigationVisible)
                ? (_openBlock(), _createBlock(_component_v_list_item, {
                    key: 0,
                    link: "",
                    class: _normalizeClass(['rounded-0', item.id === _ctx.current ? 'sm__current-item' : '']),
                    onClick: ($event: any) => (_ctx.$emit('click-item', item.id))
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_sm_badge, {
                        dot: "",
                        visible: item.badgeVisible,
                        class: "pl-2 mr-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            dark: "",
                            style: {"opacity":"1"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.icon), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["visible"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_sm_text, {
                              format: "sm__caption",
                              text: item.name
                            }, null, 8, ["text"])
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_divider)
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}